module.exports = __webpack_public_path__ + "static/media/edu.e78a1547.svg";